<!-- MODAL seleccionarPago -->
<div mdbModal #seleccionarPago="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <form [formGroup]='formData' novalidate (ngSubmit)="buscar(true)">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel">
            Seleccionar pago
          </h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="seleccionarPago.hide()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col">
              <div class="md-form">
                <input value="" type="text" id="numpago" class="form-control" placeholder="Código de pago"
                  #numpago formControlName="nroPago" onlyNumbers />
                <label for="numpago">Número de pago</label>
                <!-- <div *ngIf="
                    formData.get('nroPago').invalid &&
                    (formData.get('nroPago').dirty ||
                    formData.get('nroPago').touched)
                ">
                  <mdb-error *ngIf="formData.get('nroPago').hasError('required')">
                    Ingrese pago
                  </mdb-error>
                </div> -->
              </div>
            </div>
            <div class="col" style="max-width: 200px;">
              <div class="md-form">
                  <mdb-date-picker [inline]="true" name="fechaDesde" [placeholder]="'Fecha'" required
                      formControlName="fechaDesde">
                  </mdb-date-picker>
                  <div *ngIf="
                  formData.get('fechaDesde').invalid &&
                        (formData.get('fechaDesde').dirty ||
                        formData.get('fechaDesde').touched)
                    ">
                    <mdb-error *ngIf="formData.get('fechaDesde').hasError('required')">
                      Ingrese fecha desde
                    </mdb-error>
                  </div>
              </div>
          </div>
          <div class="col" style="max-width: 200px;">
              <div class="md-form">
                  <mdb-date-picker [inline]="true" name="fechahasta" [placeholder]="'Hasta'" required
                      formControlName="fechaHasta">
                  </mdb-date-picker>
                  <div *ngIf="
                  formData.get('fechaHasta').invalid &&
                        (formData.get('fechaHasta').dirty ||
                        formData.get('fechaHasta').touched)
                    ">
                    <mdb-error *ngIf="formData.get('fechaHasta').hasError('required')">
                      Ingrese fecha hasta
                    </mdb-error>
                  </div>
              </div>
          </div>
            <div class="col" style="width: 50px;">
              <button mdbBtn type="submit" class="btn-cuadrado" color="secondary" mdbWavesEffect>
                <mdb-icon fas icon="search"></mdb-icon>
              </button>
            </div>
          </div>

          <div class="row" *ngIf="busquedaIniciada && listaPagos.length === 0">
            <div class="col">
              <a mdbBtn color="info" class="waves-light" mdbWavesEffect>
                No existen registros para el filtro seleccionado</a>
            </div>
          </div>

          <table class="table table-striped table-hover table-sm align-middle"
            *ngIf="busquedaIniciada && listaPagos && listaPagos.length > 0">
            <thead class="grey lighten-2">
              <tr>
                <th scope="col">Nro. Pago</th>
                <!-- <th scope="col">Código</th> -->
                <th scope="col">Fecha</th>
                <th scope="col">Montos</th>
                <th scope="col">Estado reverso</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let pago of listaPagos" [class.text-muted]="pago.puede_reversar === false">
                <td>{{pago.codigo}}</td>
                <!-- <td>{{pago.pago_codigo}}</td> -->
                <td>{{pago.fecha_pago | fecha}}</td>
                <td>$ {{pago.monto | numerico}}</td>
                <td>
                  <span *ngIf="pago.puede_reversar !== false">Disponible</span>
                  <span *ngIf="pago.puede_reversar === false"
                    class="text-danger"
                    [mdbTooltip]="getMotivoReversoTooltip(pago)"
                    placement="top"
                    container="body">
                    No Disponible
                  </span>
                </td>
                <td>
                  <button mdbBtn type="button" color="indigo" mdbWavesEffect class="btn" size="sm"
                    [disabled]="pago.puede_reversar === false"
                    (click)="onSeleccionarPago(pago)">
                    Seleccionar
                  </button>
                </td>
              </tr>
            </tbody>
            <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"></app-pagination>
          </table>
        </div>
      </div>
    </form>
  </div>
</div>
